import { render, staticRenderFns } from "./territoryInfo.vue?vue&type=template&id=13e9ec6a&scoped=true"
import script from "./territoryInfo.vue?vue&type=script&lang=js"
export * from "./territoryInfo.vue?vue&type=script&lang=js"
import style0 from "./territoryInfo.vue?vue&type=style&index=0&id=13e9ec6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e9ec6a",
  null
  
)

export default component.exports